import { session as browserSessionStorage } from './browserStorage';
import { config, ConfigNotification } from './config';
import getHash from './getHash';
import { Step } from './step';

const getConfigNotifications = async (step: Step): Promise<ConfigNotification[]> =>
  (
    await Promise.all(
      config.notifications.map(async notification => ({
        notification,
        shouldShow: await shouldShowNotification(notification, step),
      }))
    )
  )
    .filter(({ shouldShow }) => shouldShow)
    .map(({ notification }) => notification);

const shouldShowNotification = async (notification: ConfigNotification, step: Step): Promise<boolean> => {
  if (notification.steps?.length && !notification.steps.includes(step)) {
    return false;
  }

  if (!isNotificationActive(notification)) {
    return false;
  }

  let notifications = browserSessionStorage.get(browserSessionStorage.KEYS.onceDailyNotifications);

  if (!notifications || notifications.expiration <= new Date().getTime()) {
    notifications = {
      expiration: new Date().setHours(24, 0, 0, 0),
      list: [],
    };
  }

  const notificationHash = await getHash(JSON.stringify(notification));

  const hasNotificationTriggered = notifications.list.includes(notificationHash);

  if (hasNotificationTriggered) {
    return false;
  } else {
    notifications.list.push(notificationHash);
    return browserSessionStorage.set(browserSessionStorage.KEYS.onceDailyNotifications, notifications);
  }
};

const isNotificationActive = (notification: ConfigNotification): boolean => {
  if (!notification.startDateTime || !notification.endDateTime) {
    return true;
  }

  const now = new Date().getTime();
  const from = new Date(notification.startDateTime).getTime();
  const to = new Date(notification.endDateTime).getTime();

  return from <= now && to >= now;
};

export default getConfigNotifications;
